<template>
    <div class="team-list">
      <match-tabs :top1="4" :matchId="matchId" sportType="橄榄球"></match-tabs>
      <div class="top-tab">
        <div :style="{ color: dataType === 'offensive' ? '#cc3232' : '' }" @click="updataType('offensive')">进攻数据</div>
        <div :style="{ color: dataType === 'offensive' ? '' : '#cc3232' }" @click="updataType('defensive')">防守数据</div>
      </div>
      <div class="data">
        <div class="left">
          <div style="height: 38px;justify-content: center;">球队</div>
          <div v-for="item in teamStatsList" :key="item.id" class="team">
            <img :src="filterImage(item.badge,30,30)" />
            <span class="overflow-text">{{ item.name }}</span>
          </div>
        </div>
        <div class="swiper-box">
          <div class="top">
            <div>
              总分数<br>
              Tps
            </div>
            <div>
              传球达阵<br>
              PaTD
            </div>
            <div>
              跑球达阵<br>
              RshTD
            </div>
            <div>
              传球码数<br>
              PaYds
            </div>
            <div>
              跑球码数<br>
              RshYds
            </div>
          </div>
          <div class="fen" v-for="item in teamStatsList" :key="item.id">
            <div>{{ item.stats.score }}</div>
            <div>{{ item.stats.passingTD }}</div>
            <div>{{ item.stats.rushingTD }}</div>
            <div>{{ item.stats.passingYds }}</div>
            <div>{{ item.stats.rushingYds }}</div>
          </div>
        </div>
      </div>
      <!-- <div v-if="dataType === 'defensive'" class="data">

      </div> -->
    </div>
</template>

<script>
import matchTabs from './components/MatchTabs'
import { getBMRugbyMatchTeamStats } from '@/api/match.js'
import { QNImageUtil } from '@/utils'

export default {
  components: { matchTabs },
  data() {
    return {
      matchId: null,
      dataType: 'offensive',
      teamStatsList: []
    };
  },
  mounted() {
    this.matchId = this.$route.query.matchId
    this.getBMRugbyMatchTeamStats()
  },
  methods: {
    getBMRugbyMatchTeamStats() {
      const obj = {
        matchId: this.matchId,
        pageSize: 500,
        index: this.dataType
      }
      getBMRugbyMatchTeamStats(obj).then(res => {
        const data = res.data
        this.teamStatsList = data.teamStatsList
        console.log(this.teamStatsList);
      })
    },
    filterImage(img, w, h, mode) {
      return QNImageUtil.imageView(img, parseInt(2 * w, 10), parseInt(2 * h, 10), mode)
    },
    updataType(type) {
      this.dataType = type
      this.getBMRugbyMatchTeamStats()
    },
  },
};
</script>

<style scoped lang="scss">
.team-list{
  .top-tab{
    display: flex;
    padding: 20px 0;
    div{
      flex: 1;
      text-align: center;
      font-size: 14px;
      font-weight: 500;
    }
  }
  .data{
    display: flex;
    border-bottom: 1px solid #fafafa;
    .left{
      width: 145px;
      text-align: center;
      div{
        width: 145px;
        height: 41px;
        display: flex;
        align-items: center;
        font-size: 14px;
        padding-left: 10px;
        box-sizing: border-box;
        border-bottom: 1px solid #fafafa;
      }
      .team{
        display: flex;
        span{
          // flex: 1;
          width: 90px;
          text-align: center;
        }
      }
      img{
        width: 30px;
        height: 30px;
      }
    }
    .swiper-box{
      width: 100%;
      overflow-x: auto;
      white-space: nowrap;
      /* 隐藏滚动条 */
      scrollbar-width: none; /* firefox */
      -ms-overflow-style: none; /* IE 10+ */
      &::-webkit-scrollbar {
          display: none; /* Chrome Safari */
      }
      .top{
        font-size: 13px;
        text-align: center;
        display: flex;
        div{
          min-width: 60px;
          font-weight: 500;
          height: 38px;
        }
      }
      .fen{
        text-align: center;
        height: 40px;
        line-height: 40px;
        // width: 100%;
        border-bottom: 1px solid #fafafa;
        display: flex;
        div{
          min-width: 60px;
          font-size: 14px;
          font-weight: 400;
        }
      }
    }
  }
}
</style>
